import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useBalance } from '../../domain/balance/hook/useBalance'
import { t } from '../../domain/language/languageUtil'

interface SessionTotalStakeProps {
  x: number
  y: number
}

const textStyle = new TextStyle({
  fontFamily: 'Arial',
  fontSize: 24,
  fill: '#ffffff',
})
export const SessionTotalStake = (props: SessionTotalStakeProps) => {
  const { currency, sessionTotalStake } = useBalance()
  return (
    <Text
      text={`${t('session_total_stake')}: ${sessionTotalStake} ${currency}`}
      x={props.x}
      y={props.y}
      style={textStyle}
      anchor={0.5}
    />
  )
}
